import { create } from "zustand";
import type { Task } from "../types";

interface TasksState {
	createModalOpen: boolean;
	urgentModalOpen: boolean;
	editModalOpen: boolean;
	statusModalOpen: boolean;
	selectedTask: Task | null;
}

interface TasksActions {
	openCreateModal: () => void;
	closeCreateModal: () => void;
	openUrgentModal: () => void;
	closeUrgentModal: () => void;
	openEditModal: (task: Task) => void;
	closeEditModal: () => void;
	openStatusModal: (task: Task) => void;
	closeStatusModal: () => void;
}

type TasksStore = TasksState & TasksActions;

export const useTasksStore = create<TasksStore>((set) => ({
	createModalOpen: false,
	urgentModalOpen: false,
	editModalOpen: false,
	statusModalOpen: false,
	selectedTask: null,

	openCreateModal: () => set({ createModalOpen: true }),
	closeCreateModal: () => set({ createModalOpen: false }),

	openUrgentModal: () => set({ urgentModalOpen: true }),
	closeUrgentModal: () => set({ urgentModalOpen: false }),

	openEditModal: (task) => set({ editModalOpen: true, selectedTask: task }),
	closeEditModal: () => set({ editModalOpen: false, selectedTask: null }),

	openStatusModal: (task) => set({ statusModalOpen: true, selectedTask: task }),
	closeStatusModal: () => set({ statusModalOpen: false, selectedTask: null }),
}));
